import { debounce } from "@util/debounce";
import { useTimelineMapService } from '../timelineMapService';

export const useElementInViewportService = (container: string, target: string, shouldListen: boolean = true) => {
  if (!shouldListen){
    return;
  }

  const { getDistanceToDocumentLeft } = useTimelineMapService();
  
  const isElementInViewport = (container: HTMLElement, target: HTMLElement) => {
    const start = getDistanceToDocumentLeft(target);
    const end = target.offsetLeft + target.offsetWidth;
    let currentPosition = container.scrollLeft + (window.innerWidth / 2);
    return currentPosition > start && currentPosition <= end;
  };

  const init = () => {
    const containerElement = document.getElementById(container) as HTMLElement;
    const targetElement = document.getElementById(target) as HTMLElement;

    const event = new CustomEvent("inViewport", { detail: { id: target } });

    containerElement.addEventListener("scroll", debounce(() => {
        if (isElementInViewport(containerElement, targetElement)) {
          containerElement.dispatchEvent(event);
        }
      }, 100)
    );
  };

  document.addEventListener("DOMContentLoaded", () => {
    init();
  });
};
